/**
 *    @author:
 *    @since:
 *
 */

import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData } from '../_common/data/input-data';
import { GAData, Path } from  "../_common/constant/page-const";
import { CCBAreYouSureValidation } from './CCB_are_you_sure.validator';
import { Confirm } from 'src/refresh/service/constant';

@Component({ 
      selector: 'CCB_are_you_sure',
      templateUrl: './CCB_are_you_sure.component.html',
      styleUrls: ['./CCB_are_you_sure.component.less'],
      //encapsulation: ViewEncapsulation.None
})
export class CCBAreYouSureComponent extends FormBaseComponent implements OnInit {

       // declare Field variable here

       constructor( protected router: Router ,
                    public timerService:TimerService,
                    public data:InputData ) {

                    super(router,timerService,null);  

                    if ( this.data.aboutChild.isChildDeceased == Confirm.YES || 
                         this.data.eligibility.isCustodyOtherThanParent == Confirm.YES )                          
                         super.setNextPage(Path.OrderSummary,Path.CCBMain);      
                    else super.setNextPage(Path.SINMain,Path.CCBMain);

                    super.setValidator(new CCBAreYouSureValidation(this));

                    ////this.clear();
       }

       public ngOnInit() {
       }
       
       public onPreviousClick() {
            super.gtag(GAData.Link,GAData.back_areYouSure);
            super.onPreviousClick();
       }

       public onNextClick() : boolean {
              this.clear();
              window.history.back();
              super.gtag(GAData.Button,GAData.continue_product);   
              return true;
       }


       public clear() {

            let CCB = this.data.CCB;

            CCB.isFromAreYourSure = true;

            if(!this.data.isNextChild){
                  CCB.primaryCaregiver = -1;
                  CCB.SSN1 = '';
                  CCB.SSN2 = '';
                  CCB.SSN3 = '';
                  CCB.careGiver = "";
                  CCB.chk_consent = false;
                  CCB.emailForReceipt = '';
             }
     }

}

